module.exports = "https://coursera_assets.s3.amazonaws.com/images/5c340dbe094567f2060f69d4957533f1.png";